module.exports = __webpack_public_path__ + "static/media/icon-angular.afecbab8.svg";